const ProAdmin = { Name: 'ProAdmin', Value: 'pro-admin', RoleUuid: '12ef518d-0141-4a4f-be09-039af06b1089' };
const ProReadOnly = { Name: 'ProReadOnly', Value: 'pro-read-only', RoleUuid: '69829e06-7fbf-49fc-9752-8dbcc31fe8eb' };
const ProPreparer = { Name: 'ProPreparer', Value: 'pro-preparer', RoleUuid: '59505f53-437d-4b9e-850a-cd3b81730af1' };
const ProReviewer = { Name: 'ProReviewer', Value: 'pro-reviewer', RoleUuid: '3f63753f-015a-4092-9847-7bc1cc54be47' };
const PsgAdmin = { Name: 'PsgAdmin', Value: 'psgadmin', RoleUuid: '76773225-3a2e-4a90-a712-ca17fa9d9cab' };
const PsgAnalyst = { Name: 'PsgAnalyst', Value: 'psganalyst', RoleUuid: '6beb9e69-c73b-4e04-b9ca-07ad3f5ebffe' };
const RepositoryOnlyUser = { Name: 'RepositoryOnlyUser', Value: 'repouser', RoleUuid: '70828ea6-1c19-452b-9aba-705b914df96b' };
const TpiqSales = { Name: 'TpiqSales', Value: 'tpiqsales', RoleUuid: 'ec89dde0-a8af-4892-bd1c-cab8617e57b5' };
const TPIQUser = { Name: 'TPIQUser', Value: 'tpiquser', RoleUuid: '3dfb5b5a-4da5-4efe-b0aa-bf02fcadf230' };
const TPDocumentationUser = { Name: 'TPDocumentationUser', Value: 'tpdocumentationuser', RoleUuid: '376a51e4-e287-413c-a5c4-392a741502ba' };
const TPSafeUser = { Name: 'TPSafeUser', Value: 'tpsafeuser', RoleUuid: '61bcbdc9-1625-4186-9288-a297e367f3ad' };

exports.ByName = {
  RepositoryOnlyUser,
  TPSafeUser,
  TPDocumentationUser,
  TPIQUser,
  ProAdmin,
  ProPreparer,
  ProReadOnly,
  ProReviewer,
  PsgAdmin,
  PsgAnalyst,
  TpiqSales
};

exports.ByRoleUuid = {
  [ProAdmin.RoleUuid]: ProAdmin,
  [ProReadOnly.RoleUuid]: ProReadOnly,
  [ProPreparer.RoleUuid]: ProPreparer,
  [ProReviewer.RoleUuid]: ProReviewer,
  [PsgAdmin.RoleUuid]: PsgAdmin,
  [PsgAnalyst.RoleUuid]: PsgAnalyst,
  [RepositoryOnlyUser.RoleUuid]: RepositoryOnlyUser,
  [TpiqSales.RoleUuid]: TpiqSales,
  [TPIQUser.RoleUuid]: TPIQUser,
  [TPDocumentationUser.RoleUuid]: TPDocumentationUser,
  [TPSafeUser.RoleUuid]: TPSafeUser
}
